const $ = jQuery.noConflict();

const sectionScroll = () => {
	// Cache DOM
	const $window = $(window);
	const body = $('html, body');
	const header = $('.header');
	const sections = $('.section');
	const sectionsLength = sections.length;

	// Functions
	function bindEvents() {
		const buttons = $('.scroll-section-btn');

		buttons.each(function () {
			const btn = $(this);
			const activeSectionColor = btn.closest('.section').data('headerColor');
			if (activeSectionColor === 'white') {
				btn.css('color', '#ffffff');
				btn.find('svg').css('fill', '#ffffff');
			} else {
				btn.css('color', '#2e2e2e');
				btn.find('svg').css('fill', '#2e2e2e');
			}

			if (btn.hasClass('scroll-section-btn__back')) {
				btn.on('click', () => {
					btn.attr('disabled', true);
					body.animate({
						scrollTop: body.offset().top,
					}, 600, () => {
						btn.attr('disabled', false);
					});
				});
				return false;
			}
			btn.on('click', () => {
				btn.attr('disabled', true);

				if ($window.width() >= 992) {
					body.animate({
						scrollTop: btn.closest('.section').next().offset().top,
					}, 600, () => {
						btn.attr('disabled', false);
					});
				} else {
					body.animate({
						scrollTop: btn.closest('.section').next().offset().top - header.height(),
					}, 600, () => {
						btn.attr('disabled', false);
					});
				}
			});
		});
	}

	function toggleScrollButtons() {
		const scrollButtons = $('.scroll-section-btn');

		if ($window.width() >= 768) {
			scrollButtons.css('display', 'flex');
		} else {
			scrollButtons.slice(1, -1).css('display', 'none');
		}
	}

	if (sectionsLength > 1) {
		const scrollBtn = `
		<button class="scroll-section-btn">Scroll
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"	width="63px" height="27px" viewBox="0 0 63 27" fill="#ffffff">
				<g><path class="st0" d="M62,13c0,0.6-0.4,1-1,1L1,14c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1l60,0C61.6,12,62,12.4,62,13z"/>
					<path class="st0" d="M62.3,13.3c0,0.3-0.1,0.5-0.3,0.7L49.7,26.3c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l11.6-11.6L48.3,1.7
						c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L62,12.6C62.2,12.8,62.3,13,62.3,13.3z"/></g>
			</svg>
   		</button>`;
		const backBtn = `
		<button class="scroll-section-btn scroll-section-btn__back">Back to top
			<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"	width="39px" height="20px" viewBox="0 0 39 20" fill="#ffffff">
				<path d="M35.1,16.8V3c0.4-0.2,0.8-0.4,1.3-0.5V17C35.9,17,35.5,16.9,35.1,16.8L35.1,16.8z M20.8,16.9V2.5c0.7,0.1,1.3,0.2,1.7,0.5
				v13.1C22,16.4,21.4,16.7,20.8,16.9L20.8,16.9z M16.5,16.6V3.5c0.5-0.4,1.1-0.6,1.7-0.8v14.4C17.5,17,16.9,16.9,16.5,16.6L16.5,16.6z
				M2.6,17V2.5c0.5,0,0.9,0.1,1.3,0.2v13.8C3.5,16.7,3.1,16.9,2.6,17L2.6,17z M0,18.6c0.1,0.7,0.6,1.2,1.3,1.2c2.8,0,5.1-1.4,6.8-3.3
				S11,12.2,12,9.9l0,0c0.5-1.2,1.1-2.5,1.8-3.6v7.1c0-0.1-0.1-0.2-0.1-0.2c-0.3-0.6-0.9-0.9-1.5-0.8c-0.6,0.2-1,0.7-1,1.4
				c0,0.2,0.1,0.3,0.1,0.5c0.7,1.6,1.6,3,2.8,4c1.3,1,2.9,1.5,4.9,1.5c2.8,0,5-1.3,6.7-3c1.6-1.7,2.8-3.9,3.6-6l0,0
				c0.9-2,1.9-4,3.1-5.5v9.5c-0.2-0.3-0.4-0.7-0.5-1.1l0,0c-0.1-0.3-0.4-0.6-0.7-0.7c-0.3-0.1-0.7-0.2-1,0c-0.3,0.1-0.6,0.4-0.7,0.7
				c-0.1,0.3-0.2,0.7,0,1c0.7,1.8,1.7,3.2,3.1,4.1s3.1,1.1,5.1,1.1c0.7,0,1.3-0.6,1.3-1.3V1.3c0-0.3-0.1-0.7-0.4-0.9
				C38.4,0.2,38,0,37.7,0c-2.8,0-5.1,1.4-6.8,3.3S28,7.6,27,9.9l0,0c-0.5,1.2-1.1,2.5-1.8,3.6V6.4c0,0.1,0.1,0.1,0.1,0.2
				c0.1,0.3,0.4,0.6,0.7,0.7s0.7,0.1,1,0s0.6-0.4,0.7-0.7c0.1-0.3,0.1-0.7,0-1c-0.7-1.6-1.5-3-2.8-4S22,0.1,20,0.1c-2.8,0-5,1.3-6.7,3
				c-1.6,1.7-2.8,3.9-3.6,6l0,0c-0.9,2-1.9,4-3.1,5.4V5c0.2,0.3,0.3,0.7,0.5,1.2l0,0c0.1,0.3,0.4,0.6,0.7,0.7s0.7,0.2,1,0
				c0.3-0.1,0.6-0.4,0.7-0.7c0.1-0.3,0.2-0.7,0-1C8.8,3.4,7.8,2,6.4,1.1C5,0.2,3.3,0,1.3,0C0.6,0,0,0.6,0,1.3l0,17.1
				C0,18.5,0,18.5,0,18.6L0,18.6z"/>
			</svg>
		</button>`;

		sections.each(function (i) {
			if ((i + 1) === sectionsLength) {
				$(this).append(backBtn);
				return false;
			}
			$(this).append(scrollBtn);
		});

		bindEvents();
		toggleScrollButtons();

		window.addEventListener('resize', () => {
			toggleScrollButtons();
		});
	}
};

export default sectionScroll;
